import { BenchmarkGroupType } from '@app/src/types/benchmark'
import type { Provider } from '@app/src/types/organizations'

const PROFILE_PEER_GROUPS: BenchmarkGroupType[] = [
  BenchmarkGroupType.Industry,
  BenchmarkGroupType.Region,
  BenchmarkGroupType.RevenueRange,
  BenchmarkGroupType.Network,
]

export function revenueRangeGroupValue(provider: Provider): string | undefined {
  return provider.revenueRange?.trim() || undefined
}

export function getAvailablePeerGroups(provider: Provider): BenchmarkGroupType[] {
  const hasValue: Record<BenchmarkGroupType, boolean> = {
    [BenchmarkGroupType.Network]: true,
    [BenchmarkGroupType.Country]: Boolean(provider.countryId),
    [BenchmarkGroupType.Region]: Boolean(provider.country?.regionId),
    [BenchmarkGroupType.Industry]: Boolean(provider.industryId),
    [BenchmarkGroupType.SubIndustry]: Boolean(provider.subIndustryId),
    [BenchmarkGroupType.RevenueRange]: Boolean(revenueRangeGroupValue(provider)),
  }
  return PROFILE_PEER_GROUPS.filter(group => hasValue[group])
}

export function resolvePeerGroup(provider: Provider, selectedPeerGroup?: BenchmarkGroupType): BenchmarkGroupType {
  const availableGroups = getAvailablePeerGroups(provider)
  if (selectedPeerGroup && availableGroups.includes(selectedPeerGroup)) return selectedPeerGroup
  return availableGroups[0] ?? BenchmarkGroupType.Network
}

export const peerGroupOptionMessageId = (group: BenchmarkGroupType): string =>
  `sustainabilityProfile.benchmark.options.${group}`
